import http from '../../utils/httpClient';
import moment from 'moment';
import swal from 'sweetalert2';
import router from '../../router';
const state = {
  labeling: [],
  selectLabeling: {},
  selectedSetIndex: -1,
  selectedCategoryId: '',
  updateCardData: {},
  updateLabelSetData: {},
  isUpdating: false,
  cardData: {
    clickable: true,
    name: '',
    image_holder_uri: '',
    image_colour_uri: '',
    sound_uri: '',
    nana_pop: [
      {
        action: '',
        type: '',
        objectData: '',
      },
    ],
  },
  addCardData: [
    {
      clickable: true,
      name: '',
      image_holder_uri: '',
      image_colour_uri: '',
      sound_uri: '',
      nana_pop: [
        {
          action: '',
          type: '',
          objectData: '',
        },
      ],
    },
  ],
  addLabelSetData: {
    name: '',
  },
  eventData: {
    startX: '',
    startY: '',
    endX: '',
    endY: '',
  },
};
const getters = {};
const actions = {
  fetchLabeling({ commit, dispatch }, { page = 1, limit = 0 }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/labeling/category?page=${page}&limit=${limit}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(labeling => ({
          ...labeling,
          created_at: moment(labeling.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(labeling.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeLabeling', formatData);
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'labeling fetch labeling in this time please type again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  selectLabeling({ commit }, data) {
    commit('storeSelectLabeling', data);
  },
  selectCategory({ commit }, id) {
    commit('storeSelectCategory', id);
  },
  fetchSingleLabeling({ commit, dispatch }, { id, sub_id }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/labeling?category_id=${id}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const [formatData] = data.map(labeling => ({
          ...labeling,
          created_at: moment(labeling.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(labeling.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeSelectLabeling', { ...formatData, sub_id });
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Cannot fetch labeling at this time. Please try again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  updateCardData({ commit }, { key, value }) {
    commit('storeUpdateCardData', {
      key,
      value,
    });
  },
  updateLabelSetData({ commit }, { key, value }) {
    commit('storeUpdateLabelSetData', {
      key,
      value,
    });
  },
  updateCard({ dispatch }, updateData) {
    if (Object.keys(updateData).length > 1) {
      http
        .PUT(
          '/api/choice',
          {
            ...updateData,
          },
          {
            isAuthorization: true,
          },
        )
        .then(() => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Update Card Success.',
              type: 'success',
            },
            {
              root: true,
            },
          );
          dispatch('fetchSingleLabeling', {
            id: state.selectLabeling.category_id,
          });
        })
        .catch(() => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Failed to update card. Please Try again',
              type: 'error',
            },
            {
              root: true,
            },
          );
        });
    }
  },
  clearUpdateData({ commit }) {
    commit('clearStoreUpdateCardData');
  },

  deleteLabelSet({ dispatch, state }, id) {
    swal
      .fire({
        titleText: 'Confirm Delete LabelSet',
        showCancelButton: true,
        type: 'warning',
      })
      .then(result => {
        if (result.value) {
          http
            .DELETE(`/api/labeling/set?_id=${id}`, {
              isAuthorization: true,
            })
            .then(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Delete Successfully',
                  type: 'success',
                },
                { root: true },
              );
              dispatch('fetchSingleLabeling', {
                id: state.selectLabeling.category_id,
              });
            })
            .catch(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Cannot delete label set. Please try again later !',
                  type: 'error',
                },
                { root: true },
              );
            });
        }
      });
  },
  deleteCard({ dispatch, state }, id) {
    swal
      .fire({
        titleText: 'Confirm Delete Card',
        showCancelButton: true,
        type: 'warning',
      })
      .then(result => {
        if (result.value) {
          http
            .DELETE(`/api/choice?_id=${id}`, {
              isAuthorization: true,
            })
            .then(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Delete Successfully',
                  type: 'success',
                },
                { root: true },
              );
              dispatch('fetchSingleLabeling', {
                id: state.selectLabeling.category_id,
              });
            })
            .catch(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Cannot delete card please try again later !',
                  type: 'error',
                },
                { root: true },
              );
            });
        }
      });
  },
  updateCreateCardData({ commit }, { key, value, index }) {
    commit('storeCreateCardData', {
      key,
      value,
      index,
    });
  },
  updateCreateSingleCardData({ commit }, { key, value }) {
    commit('storeCreateSingleCardData', {
      key,
      value,
    });
  },
  updateLabelSet({ dispatch }, updateData) {
    if (Object.keys(updateData).length > 1) {
      http
        .PUT('/api/labeling/set', updateData, {
          isAuthorization: true,
        })
        .then(() => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Edit LabelSet success',
              type: 'success',
            },
            {
              root: true,
            },
          );
          dispatch('fetchSingleLabeling', {
            id: state.selectLabeling.category_id,
          });
        })
        .catch(() => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Edit LabelSet failed please try again later',
              type: 'error',
            },
            {
              root: true,
            },
          );
        });
    }
  },
  updateCreateLabelSetData({ commit }, { key, value }) {
    commit('storeCreateLabelSetData', {
      key,
      value,
    });
  },
  addLabelSet({ dispatch }, { category_id, ...data }) {
    const createLabelSetData = {
      category_id,
      label_sets: {
        ...data.labelSet,
      },
      choice: [...data.cards],
    };
    http
      .POST('/api/labeling', createLabelSetData, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create LabelSet success',
            type: 'success',
          },
          {
            root: true,
          },
        );
        dispatch('fetchSingleLabeling', { id: category_id });
        router.go({
          path: '/labeling/detail',
          query: {
            id: category_id,
          },
        });
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create LabelSet failed',
            type: 'error',
          },
          {
            root: true,
          },
        );
      });
  },
  addCardByLabelSetId({ dispatch }, { category_id, labelset_id, ...data }) {
    const createCardData = {
      _id: labelset_id,
      choice: { ...data.card },
    };
    http
      .POST('/api/labeling/set', createCardData, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Add Card success',
            type: 'success',
          },
          {
            root: true,
          },
        );
        dispatch('fetchSingleLabeling', { id: category_id });
        router.go({
          path: '/labeling/detail',
          query: {
            id: category_id,
          },
        });
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Add Card failed',
            type: 'error',
          },
          {
            root: true,
          },
        );
      });
  },
};
const mutations = {
  toggleStoreUpdate(state) {
    state.isUpdating = !state.isUpdating;
  },
  storeLabeling(state, labelingList) {
    state.labeling = labelingList;
  },
  storeSelectLabeling(state, data) {
    if (data) {
      state.selectLabeling = data;
      if (data.sub_id) {
        const setIndex = state.selectLabeling.label_sets.findIndex(
          set => set._id === data.sub_id,
        );
        state.selectedSetIndex = setIndex;
      }
      delete state.selectLabeling.sub_id;
    } else {
      delete state.selectLabeling;
    }
  },
  storeSelectCategory(state, value) {
    if (value) {
      state.selectedCategoryId = value;
    } else {
      delete state.selectedCategoryId;
    }
  },
  storeUpdateCardData(state, { key, value }) {
    state.updateCardData = {
      ...state.updateCardData,
      [key]: value,
    };
  },
  storeCreateCardData(state, { key, value, index }) {
    state.addCardData[index] = {
      ...state.addCardData[index],
      [key]: value,
    };
  },
  storeCreateSingleCardData(state, { key, value }) {
    state.addSingleCardData = {
      ...state.addSingleCardData,
      [key]: value,
    };
  },
  storeUpdateLabelSetData(state, { key, value }) {
    state.updateLabelSetData = {
      ...state.updateLabelSetData,
      [key]: value,
    };
  },
  storeCreateLabelSetData(state, { key, value }) {
    state.addLabelSetData = {
      ...state.addLabelSetData,
      [key]: value,
    };
  },
  clearStoreUpdateCardData(state) {
    Object.keys(state.updateCardData).forEach(key => {
      if (key != '_id') {
        delete state.updateCardData[key];
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
